import PhoneInput from "../../../../components/PhoneInput";
import { toPhoneDigits } from "../../../../helper/phoneUtils";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import AsyncTypeahead, { DataListType } from "../../../../components/AsyncTypeahead";
import { createCommonUtilsApi, createContactTypeApi, createLocationApi } from "../../../../api-helpers/CommonUtilsApiHelper";
import { IdValuePairDTO, Lookup } from "common-util-experience-client";
import Toaster, { ToastConfig } from "../../../../components/Toaster";
import { ErrorTypes } from "../../../../interfaces/errors";
import { createPatientApi } from "../../../../api-helpers/PatientApiHelper";
import { AddExternalContact, PhoneTypesResponse, UpdateExternalContact } from "patients-experience-client";
import Spinner from "../../../../components/Spinner";
import Lookups from "../../../../constants/Lookups";
import { createProvidersApi } from "../../../../api-helpers/UserApiHelper";
import { ProvidersDto } from "users-experience-client";

interface FullName {
    credential?: string;
    firstName?: string;
    lastName?: string;
}

export const AddUpdateExternalCareTeamMembers = (props: any) => {
    const locationApi = createLocationApi()
    const providersApi = createProvidersApi();
    const apiLookup = createCommonUtilsApi()
    const patientApi = createPatientApi();
    const contactTypesApi = createContactTypeApi();
    const [loading, setloading] = useState(false);
    const [contactTypes, setContactTypes] = useState<Array<IdValuePairDTO>>([]);
    const [selectedContact, setSelectedContact] = useState<Array<IdValuePairDTO>>([]);
    const [specialities, setSpecialities] = useState<Array<Lookup>>([]);
    const [showToast, setShowToast] = useState(false);
    const [states, setStates] = useState<Array<DataListType>>([]);
    const [validState, setValidState] = useState<boolean>(true);
    const [validated, setValidated] = useState(false);
    const [phoneTypes, setPhoneTypes] = useState<Array<PhoneTypesResponse>>([]);
    const [selectedProvider, setSelectedProvider] = useState<ProvidersDto>();
    const [providers, setProviders] = useState<Array<DataListType>>([]);
    const [disabled, setDisabled] = useState<boolean>(false);
    const [toastConfig, setToastConfig] = useState<ToastConfig>({
        type: "success" as ErrorTypes,
        title: "",
        icon: "",
    });

    const [careMemberName, setCareMemberName] = useState<FullName>()
    const [form, setForm] = useState<UpdateExternalContact | AddExternalContact>({
        contactTypeId: props.selectedExternalCareMember?.contactType.id || "",
        specialtyId: props.selectedExternalCareMember?.speciality.id || "",
        phone: toPhoneDigits(props.selectedExternalCareMember?.phone),
        npi: props.selectedExternalCareMember?.npi || "",
        stateId: props.selectedExternalCareMember?.state?.id || "",
        primaryTaxonomy: props.selectedExternalCareMember?.primaryTaxonomy || "",
        secondaryTaxonomy: props.selectedExternalCareMember?.secondaryTaxonomy || "",
        credential: props.selectedExternalCareMember?.contactCredential || "",
        firstName: props.selectedExternalCareMember?.contactFirstName || "",
        lastName: props.selectedExternalCareMember?.contactLastName || "",
        phoneTypeId: props.selectedExternalCareMember?.phoneType.id || "",
    });

    const handleDiscard = () => {
        props.setOffCanvasShow(false);
    };

    useEffect(() => {
        loadContactTypes();
        loadSpecialities();
        loadPhoneTypes();
        setDisabled(props.selectedExternalCareMember?.contactType.name.toLocaleLowerCase() === 'provider');
    }, []);

    const loadStates = async (query: string) => {
        if (!query) {
            setStates([]);
            return;
        }
        try {
            const response = await locationApi.locationControllerSearchStates(query);
            const options: DataListType[] = response.data.map((item: any) => ({
                key: item.id,
                value: item.value,
            }));
            setStates(options);
        } catch (error: any) {
            console.log(error);
        }
    }

    const loadPhoneTypes = async () => {
        setloading(true);
        try {
            const response = await patientApi.patientsControllerGetphoneTypes();
            setPhoneTypes(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setloading(false);
        }
    }

    const selectState = (selected: any) => {
        setForm({
            ...form,
            stateId: selected && selected.key
        });
    };

    const loadProviders = async (query: string) => {
        if (!query) {
            setProviders([]);
            return;
        }
        try {
            const response = await providersApi.providersControllerSearchProviders(query);
            const options: DataListType[] = response.data.map((item: any) => ({
                key: item.key,
                value: item.value,
            }));
            setProviders(options);
        } catch (error: any) {
            console.log(error);
        }
    }

    const resetForm = async () => {
        form.specialtyId = '';
        form.phone = '';
        form.npi = '';
        form.stateId = '';
        form.primaryTaxonomy = '';
        form.secondaryTaxonomy = '';
        await setCareMemberName({
            ...careMemberName,
            credential: "",
            firstName: "",
            lastName: "",
        });
    }

    const selectProvider = async (selected: any) => {
        setSelectedProvider(undefined);
        if (selected) {
            setForm({
                ...form,
                firstName: selected && selected.value
            });
            try {
                setloading(true);
                const response = (await providersApi.providersControllerFindOne(selected.key)).data;
                setSelectedProvider(response);

                setForm({
                    ...form,
                    specialtyId: response.speciality.id,
                    phone: toPhoneDigits(response.phone),
                    npi: response.npi,
                    stateId: response.state.id,
                    primaryTaxonomy: response.primaryTaxonomy,
                    secondaryTaxonomy: response.secondaryTaxonomy,
                    credential: response.credential,
                    firstName: response.firstName,
                    lastName: response.lastName,
                    phoneTypeId: response.phoneTypeId
                })
            } catch (error: any) {
                console.error(error);
            } finally {
                setloading(false);
            }

        }
    };

    useEffect(() => {
        setForm({
            ...form,
            firstName: ''
        });
    }, [selectedContact]);

    const loadContactTypes = async () => {
        setloading(true);
        try {
            const response = await contactTypesApi.contactTypeControllerGetAll('false');
            setContactTypes(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setloading(false);
        }
    }

    const loadSpecialities = async () => {
        setloading(true);
        try {
            const response = await apiLookup.lookupControllerFindAll(Lookups.SPECIALITY);
            setSpecialities(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setloading(false);
        }
    };

    const showSuccessMessage = () => {
        setShowToast(false);
        const toasterConfig: ToastConfig = {
            type: "success",
            title: "External Care Team Member updated successfully!",
            icon: "check_circle_outline",
        };
        setToastConfig(toasterConfig);
        setShowToast(true);
    }

    const showErrorMessage = (message: string) => {
        setShowToast(false);
        const toasterConfig: ToastConfig = {
            type: "danger",
            title: message,
            icon: "error_outline",
        };
        setToastConfig(toasterConfig);
        setShowToast(true);
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        if (name === 'npi' && value.length) {
            if (value.length > 10) {
                return;
            }
            if (value !== '' && !/^\d+$/.test(value)) {
                return;
            }
        }
        if (name === 'phone' && value.length < 10) {
            setForm({ ...form, [name]: value });
            setValidated(false);
            return;
        }
        if (name === 'contactTypeId') {
            resetForm();
            const selected = contactTypes.filter((type: IdValuePairDTO) => type.id === value);
            setSelectedContact(selected);
            setDisabled(selected[0]?.value?.toLocaleLowerCase() === 'provider');
        }
        setForm({
            ...form,
            [name]: value
        });
        if (name === 'credential' || name === 'firstName' || name === 'lastName') {
            setCareMemberName({
                ...careMemberName,
                [name]: value
            });
        }
    };

    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        const phoneInput = document.querySelector('[name="phone"]') as HTMLInputElement;
        const npiInput = document.querySelector('[name="npi"]') as HTMLInputElement;
        phoneInput.setCustomValidity("");
        npiInput.setCustomValidity("");
        event.preventDefault();
        setValidated(true);

        await setValidState(true);
        if (!form.stateId) {
            !form.stateId && setValidState(false);
        }

        if (form?.phone?.length !== 10) {
            phoneInput.setCustomValidity("Invalid Phone Number");
        } else {
            phoneInput.setCustomValidity("");
        }

        if (form?.npi?.length && form?.npi?.length !== 10) {
            npiInput.setCustomValidity("Invalid NPI Number");
        } else {
            npiInput.setCustomValidity("");
        }
        if (form?.phone?.length !== 10 || (form?.npi?.length && form?.npi?.length !== 10)) {
            return;
        } 

        const addForm = event.target as HTMLFormElement;
        if (!addForm.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        setloading(true);
        try {
            if(form.stateId === '') {
                form.stateId = undefined;
            }

            const submitForm: any = form;
            if(!disabled){ //if contact type is not provider, enabled contact fields
                submitForm.credential = careMemberName?.credential;
                submitForm.firstName = careMemberName?.firstName;
                submitForm.lastName = careMemberName?.lastName;
            }            

            if (props.selectedExternalCareMember == undefined) {
                await patientApi.patientsControllerCreatePatientExternalContact(submitForm as AddExternalContact, props.patientId!);
            } else {
                await patientApi.patientsControllerUpdateExternalContact(form as UpdateExternalContact, props.patientId!, props.selectedExternalCareMember.contactId!);
            }
            setloading(false);
            showSuccessMessage();
            setTimeout(() => {
                handleDiscard();
            }, 1500);
            props.getExternalCareTeamMembers();
        } catch (error) {
            console.error(error);
            setloading(false);
            showErrorMessage("An unexpected error occurred while submitting the form.");
        }
    };

    return (
        <>
            {loading && <Spinner />}
            <div className="row">
                <Toaster
                    show={showToast}
                    onClose={() => setShowToast(false)}
                    type={toastConfig.type}
                    title={toastConfig.title}
                    message={toastConfig.message}
                    icon={toastConfig.icon}
                />
            </div>
            <Form
                noValidate
                validated={validated}
                onSubmit={submitHandler}
                className="d-flex flex-column h-100">
                <div className="flex-fill">
                    <div className="row g-2 mb-3">
                        <div className="col-6">
                            <div className="mb-3">
                                <label
                                    className="form-label fs-12 fw-semibold mb-1"
                                >
                                    Contact Person
                                </label>
                                <select name="contactTypeId" value={form.contactTypeId} onChange={handleInputChange}
                                    className="form-select" required
                                    disabled={props.selectedExternalCareMember}

                                >
                                    <option value="">Select</option>
                                    {
                                        contactTypes.map((type: IdValuePairDTO) =>
                                            <option key={type.id} value={type.id} selected>{type.value}</option>
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label
                                    className="form-label fs-12 fw-semibold mb-1"
                                >
                                    Speciality
                                </label>
                                <select name="specialtyId" value={form.specialtyId} onChange={handleInputChange}
                                    className="form-select" required disabled={disabled}
                                >
                                    <option value="">Select</option>
                                    {
                                        specialities.map((speciality: Lookup) =>
                                            <option key={speciality.id} value={speciality.id} selected>{speciality.name}</option>
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                        {disabled ? //if contact type is provider, disabled contact fields
                            <>
                                <div className="col-12">
                                    <div className="mb-3">
                                        <label className="form-label fs-12 fw-semibold mb-1">Full Name</label>
                                        <AsyncTypeahead
                                            name="contactName"
                                            options={providers}
                                            callback={loadProviders}
                                            onSelect={selectProvider}
                                            placeholder={"Provider Name"}
                                            // defaultValue={props?.selectedExternalCareMember?.contactFirstName + ' ' + props?.selectedExternalCareMember?.contactLastName}
                                            required={true}
                                            isValid={validState}
                                            disabled={props.selectedExternalCareMember}
                                            unsetId={resetForm}
                                        ></AsyncTypeahead>
                                    </div>
                                </div>
                            </> :
                            <>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label
                                            className="form-label fs-12 fw-semibold mb-1"
                                        >
                                            First Name
                                        </label>
                                        {
                                            props.selectedExternalCareMember ?
                                                <div className="mb-3 row">
                                                    <div className="col-4 pe-0">
                                                        <input type="text" className="form-control px-1"
                                                            disabled={true} placeholder="Cred."
                                                            value={props.selectedExternalCareMember?.contactCredential} />
                                                    </div>
                                                    <div className="col-8 ps-2">
                                                        <input type="text" className="form-control" placeholder="First Name"
                                                            disabled={true}
                                                            value={props.selectedExternalCareMember?.contactFirstName} />
                                                    </div>
                                                </div> :
                                                <div className="mb-3 row">
                                                    <div className="col-4 pe-0">
                                                        <input type="text" className="form-control px-1"
                                                            placeholder="Cred."
                                                            name="credential" onChange={handleInputChange}
                                                            value={careMemberName?.credential} />
                                                    </div>
                                                    <div className="col-8 ps-2">
                                                        <input type="text" className="form-control"
                                                            placeholder="First Name" name="firstName" onChange={handleInputChange}
                                                            value={careMemberName?.firstName} required={true} />
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label
                                            className="form-label fs-12 fw-semibold mb-1"
                                        >
                                            Last Name
                                        </label>
                                        {
                                            props.selectedExternalCareMember ?
                                                <div className="input-group mb-3">
                                                    <input type="text" className="form-control"
                                                        disabled={true} placeholder="Last Name"
                                                        value={props.selectedExternalCareMember?.contactLastName} />
                                                </div> :
                                                <div className="input-group mb-3">
                                                    <input type="text" className="form-control"
                                                        placeholder="Last Name" name="lastName" onChange={handleInputChange}
                                                        value={careMemberName?.lastName} required={true} />
                                                </div>
                                        }
                                    </div>
                                </div>
                            </>
                        }
                        <div className="col-6">
                            <div className="mb-3">
                                <label
                                    className="form-label fs-12 fw-semibold mb-1"
                                >
                                    Phone Type
                                </label>
                                <select name="phoneTypeId" value={form.phoneTypeId} onChange={handleInputChange}
                                    className="form-select" required disabled={disabled}
                                >
                                    <option value="">Select</option>
                                    {
                                        phoneTypes.map((pt: PhoneTypesResponse) =>
                                            <option key={pt.id} value={pt.id} selected>{pt.name}</option>
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label
                                    className="form-label fs-12 fw-semibold mb-1"
                                >
                                    Phone
                                </label>
                                <PhoneInput required name="phone" value={form.phone} onChange={handleInputChange} disabled={disabled} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label
                                    className="form-label fs-12 fw-semibold mb-1"
                                >
                                    NPI
                                </label>
                                <input type="text" disabled={disabled} className="form-control" name="npi" value={form.npi} placeholder="NPI" onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label
                                    className="form-label fs-12 fw-semibold mb-1"
                                >
                                    State
                                </label>
                                <AsyncTypeahead
                                    disabled={disabled}
                                    name="stateId"
                                    options={states}
                                    callback={loadStates}
                                    onSelect={selectState}
                                    placeholder={"State"}
                                    defaultValue={selectedProvider?.state?.name || props.selectedExternalCareMember?.state?.name}
                                    isValid={validState}
                                    resetInput={form.stateId === ''}
                                ></AsyncTypeahead>
                            </div>
                        </div>
                    </div>
                    <div className="row g-2 mb-3">
                        <div className="col-6">
                            <div className="mb-3">
                                <label
                                    className="form-label fs-12 fw-semibold mb-1"
                                >
                                    Primary Taxonomy
                                </label>
                                <input disabled={disabled} type="text" className="form-control" name="primaryTaxonomy" value={form.primaryTaxonomy} placeholder="Primary Taxonomy" onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="mb-3">
                                <label
                                    className="form-label fs-12 fw-semibold mb-1"
                                >
                                    Secondary Taxonomy
                                </label>
                                <input disabled={disabled} type="text" className="form-control" name="secondaryTaxonomy" value={form.secondaryTaxonomy} placeholder="Secondary Taxonomy" onChange={handleInputChange} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="offcanvas-footer text-end w-100 border-top d-flex justify-content-between border-top">
                    <div>
                        <button
                            className="btn btn-outline-secondary rounded-pill px-5 fs-13"
                            type="reset"
                            onClick={handleDiscard}
                        >
                            Discard
                        </button>
                    </div>
                    <div>
                        <button
                            className="btn btn-secondary rounded-pill ps-4 pe-5 fs-13"
                            type="submit"
                        >
                            {
                                props.selectedExternalCareMember ? 'Update' : (
                                    <>

                                        Add
                                    </>
                                )
                            }
                        </button>
                    </div>
                </div>
            </Form>
        </>
    );
};